import { frfr_alien_editorjs_editorjs_renderable_data_validator_quick_incomplete } from "../frfr-alien-editorjs-utils";
import { Easy69_v1 } from "../frfr-easy69-utils";
import { js_utils } from "../frfr-js-utils";
import { rapidozi_contact_utils } from "../frfr-rapidozi-contact-utils";
import { _zzyourmap_fix_layer_title } from "./zz-yourmap-layer-utils";
import { _zzyourmap_extract_editorjs_renderable_data, _zzyourmap_make_empty_special_blog_post_data } from "./zz-yourmap-blog-post-utils";
import { _zzyourmap_lib_tab_keys } from "./zz-yourmap-data-keys-and-values-lib";


// ADMIN FORMS, INITIAL STATE/PRESET, SUBMIT UTILS...


//
export const _zzyourmap_formDefinition_adminLogin = [
  /*
  {
    "type": "input_email",
    "params": {
      "label": "email",
      "name": "email",
      // "w": 320
    }
  },
  */
  {
    "type": "input_text",
    "params": {
      "label": "username",
      "name": "username",
      // "w": 320
    }
  },
  {
    "type": "input_password",
    "params": {
      "label": "password",
      "name": "password",
      // "w": 320
    }
  },
];


//
export const _zzyourmap_formDefinition_ymthing_prefilter_vr_tablename = () => {
  return [
    //
    /*
    {
      "type": "separator",
    },
    */
    {
      "type": "input_radio_group",
      "params": {
        "label": "vr_tablename",
        "name": "vr_tablename",
        "options": [
          { "title": 'Prikaži sve', "value": '' },
          { "title": 'Smeštaj', "value": 'ym_table_smestaj' },
          { "title": 'Restoran', "value": 'ym_table_restoran' },
          { "title": 'Servis', "value": 'ym_table_servis' },
          { "title": 'Prodavnice', "value": 'ym_table_prodavnica' },
          { "title": 'Aktivnosti', "value": 'ym_table_aktivnost' },
          { "title": 'Znamenitosti', "value": 'ym_table_znamenitost' },
          { "title": 'Ostalo', "value": 'ym_table_ostalo_v2' },
          { "title": '*ignored', "value": 'ym_table_ignored' },
        ],
        "style_row": true,
        "style_outline": false,
      }
    },
  ];
};


// ----- FORM PARTS


//
export const _zzyourmap_formDefinition_formPart_editing = [
  {
    "type": "row",
    "params": {
      "children": [
        {
          "type": "input_number",
          "params": {
            "readonly": true,
            "label": "Rev. id",
            "name": "id",
            "w": 80
          }
        },
        {
          "type": "input_number",
          "params": {
            "readonly": true,
            "label": "of_id",
            "name": "of_id",
            "w": 80
          }
        },
      ]
    },
  },
];


//
export const _zzyourmap_formDefinition_smestaj_formPart_vr_tablename = () => {
  return [
    //
    /*
    {
      "type": "separator",
    },
    */
    {
      "type": "input_radio_group",
      "params": {
        "label": "vr_tablename",
        "name": "vr_tablename",
        "options": [
          { "title": 'ym_table_smestaj', "value": 'ym_table_smestaj' },
          { "title": 'ym_table_restoran', "value": 'ym_table_restoran' },
          { "title": 'ym_table_servis', "value": 'ym_table_servis' },
          { "title": 'ym_table_prodavnica', "value": 'ym_table_prodavnica' },
          { "title": 'ym_table_aktivnost', "value": 'ym_table_aktivnost' },
          { "title": 'ym_table_znamenitost', "value": 'ym_table_znamenitost' },
          { "title": 'ym_table_ostalo_v2', "value": 'ym_table_ostalo_v2' },
          { "title": 'ym_table_ignored (vidljivi samo u admin panelu)', "value": 'ym_table_ignored' },
        ],
      }
    },
  ];
};


//
export const _zzyourmap_formDefinition_smestaj_formPart_parent_destinacija_id = (options_adm_parent_of_smestaj) => {
  return [
    //
    {
      "type": "row",
      "params": {
        "children": [
          {
            "type": "select",
            "params": {
              "valuetype": "number",
              "label": "parent_destinacija_id",
              "name": "parent_destinacija_id",
              "options": [...options_adm_parent_of_smestaj],
              "w": 320
            }
          },
          {
            "type": "input_number",
            "params": {
              "readonly": true,
              "label": "",
              "name": "parent_destinacija_id",
              "w": 60
            }
          },
        ],
      },
    },
  ];
};


//
export const _zzyourmap_formDefinition_smestaj_formPart_kontakt = () => {
  return [
    //
    {
      "type": "separator",
    },
    {
      "type": "html_tag_text",
      "params": {
        "title": "Kontakt",
        "tag": "h4",
        "extraclass": "yourmap__form-part-heading"
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "telefon",
        "name": "telefon",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "telefon2",
        "name": "telefon2",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "mobilni",
        "name": "mobilni",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "mobilni2",
        "name": "mobilni2",
        // "w": 320
      }
    },
    {
      "type": "input_email",
      "params": {
        "label": "email",
        "name": "email",
        // "w": 320
      }
    },
    {
      "type": "input_email",
      "params": {
        "label": "email2",
        "name": "email2",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "websajt",
        "name": "websajt",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "kontakt_instagram_url",
        "name": "kontakt_instagram_url",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "Google Maps iframe src",
        "name": "google_maps_iframe_src",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "Geo URI",
        "name": "geo_uri",
        // "w": 320
      }
    },
  ];
};


//
const _zzyourmap_preset_smestaj_part_checks = {
  //
  "check_hotel": false,
  "check_apartman": false,
  "check_vila": false,
  "check_wifi": false,
  "check_klima": false,
  "check_parking": false,
  "check_garaza": false,
  "check_dorucak": false,
  "check_bazen": false,
  "check_spa": false,
  //
};
//
export const _zzyourmap_formDefinition_smestaj_formPart_checks = () => {
  let _checks_def = Object.keys(_zzyourmap_preset_smestaj_part_checks).map(checkbox_key => {
    return {
      "type": "input_checkbox",
      "params": {
        "label": checkbox_key,
        "name": checkbox_key,
        // "w": 60
      }
    };
  });
  // return _checks_def;
  return [
    //
    {
      "type": "separator",
    },
    {
      "type": "html_tag_text",
      "params": {
        "title": "Checks (Da/Ne, Ima/Nema)...",
        "tag": "h4",
        "extraclass": "yourmap__form-part-heading"
      }
    },
    ..._checks_def,
  ];
};


// _zzyourmap_formDefinition_smestaj_part_main_img
export const _zzyourmap_formDefinition_destination_formPart_main_img = () => {
  return [
    //
    {
      "type": "separator",
    },
    {
      "type": "html_tag_text",
      "params": {
        "title": "Main image destinacije",
        "tag": "h4",
        "extraclass": "yourmap__form-part-heading"
      }
    },
    {
      "type": "input_text",
      "params": {
        "readonly": true,
        "label": "destinacija_main_img_filename",
        "name": "destinacija_main_img_filename",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "readonly": true,
        "label": "destinacija_main_img_folder",
        "name": "destinacija_main_img_folder",
        // "w": 320
      }
    },
  ];
};


// _zzyourmap_formDefinition_smestaj_part_main_img
export const _zzyourmap_formDefinition_smestaj_formPart_main_img = () => {
  return [
    //
    {
      "type": "separator",
    },
    {
      "type": "html_tag_text",
      "params": {
        "title": "Main image",
        "tag": "h4",
        "extraclass": "yourmap__form-part-heading"
      }
    },
    {
      "type": "input_text",
      "params": {
        "readonly": true,
        "label": "smestaj_main_img_filename",
        "name": "smestaj_main_img_filename",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "readonly": true,
        "label": "smestaj_main_img_folder",
        "name": "smestaj_main_img_folder",
        // "w": 320
      }
    },
  ];
};


//
export const _zzyourmap_formDefinition_smestaj_formPart_gallery = () => {
  return [
    //
    {
      "type": "separator",
    },
    {
      "type": "html_tag_text",
      "params": {
        "title": "Gallery images",
        "tag": "h4",
        "extraclass": "yourmap__form-part-heading"
      }
    },
  ];
};


//
export const _zzyourmap_formDefinition_smestaj_formPart_marker = () => {
  return [
    //
    {
      "type": "separator",
    },
    {
      "type": "html_tag_text",
      "params": {
        "title": "Marker",
        "tag": "h4",
        "extraclass": "yourmap__form-part-heading"
      }
    },
    {
      "type": "row",
      "params": {
        "children": [
          {
            "type": "input_checkbox",
            "params": {
              "label": "Prikaži marker na mapi",
              "name": "smestaj_marker_enabled",
              "w": 220
            }
          },
          {
            "type": "select",
            "params": {
              // "valuetype": "number",
              "label": "Marker animacija",
              "name": "smestaj_marker_animacija",
              "options": [
                { "title": "Bez animacije", "value": "static" },
                { "title": "Skok", "value": "bounce" },
                { "title": "Blagi skok", "value": "bounce_10" },
                { "title": "Pulsiranje", "value": "pulse" },
                { "title": "Lepršanje", "value": "float" },
                { "title": "Njihanje", "value": "wiggle" },
                { "title": "Drmanje 1", "value": "shake_1" },
                { "title": "Drmanje 2", "value": "shake_2" },
              ],
              "w": 270
            }
          },
        ]
      },
    },
    {
      "type": "input_checkbox",
      "params": {
        "label": "Isključi zoom",
        "name": "smestaj_marker_zoom_disabled",
        // "w": 320
      }
    },
    {
      "type": "input_checkbox",
      "params": {
        "label": "Prati zoom mape",
        "name": "smestaj_marker_zoom_follow_enabled",
        // "w": 320
      }
    },
    {
      "type": "input_checkbox",
      "params": {
        "label": "Stepenasti zoom markera",
        "name": "smestaj_marker_zoom_step_enabled",
        // "w": 320
      }
    },
    {
      "type": "input_checkbox",
      "params": {
        "label": "smestaj_marker_is_link",
        "name": "smestaj_marker_is_link",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "smestaj_marker_link_href",
        "name": "smestaj_marker_link_href",
        // "w": 320
      }
    },
    {
      "type": "select",
      "params": {
        "label": "smestaj_marker_link_target",
        "name": "smestaj_marker_link_target",
        "options": [
          { "title": "novi tab", "value": "_blank" },
          { "title": "isti tab", "value": "_self" }
        ],
        "w": 220
      }
    },
    {
      "type": "input_text",
      "params": {
        "readonly": true,
        "label": "smestaj_marker_img_filename",
        "name": "smestaj_marker_img_filename",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "readonly": true,
        "label": "smestaj_marker_img_folder",
        "name": "smestaj_marker_img_folder",
        // "w": 320
      }
    },
    {
      "type": "row",
      "params": {
        "children": [
          {
            "type": "input_number",
            "params": {
              // "readonly": true,
              "label": "Marker w",
              "name": "smestaj_marker_img_w",
              "w": 80
            }
          },
          {
            "type": "input_number",
            "params": {
              // "readonly": true,
              "label": "Marker h",
              "name": "smestaj_marker_img_h",
              "w": 80
            }
          },
          {
            "type": "input_number",
            "params": {
              // "readonly": true,
              "label": "Anchor left",
              "name": "smestaj_marker_img_anchor_left",
              "w": 80
            }
          },
          {
            "type": "input_number",
            "params": {
              // "readonly": true,
              "label": "Anchor top",
              "name": "smestaj_marker_img_anchor_top",
              "w": 80
            }
          },
        ]
      },
    },
    {
      "type": "row",
      "params": {
        "children": [
          {
            "type": "input_number",
            "params": {
              // "readonly": true,
              "label": "Marker poz. left",
              "name": "smestaj_marker_img_left",
              "w": 140
            }
          },
          {
            "type": "input_number",
            "params": {
              // "readonly": true,
              "label": "Marker poz. bottom",
              "name": "smestaj_marker_img_bottom",
              "w": 140
            }
          },
        ]
      },
    },
  ];
};


//
const _zzyourmap_formDefinition_smestaj_formPart_tab_select = () => {
  return [
    {
      "type": "separator",
    },
    {
      "type": "html_tag_text",
      "params": {
        "title": "Tab",
        "tag": "h4",
        "extraclass": "yourmap__form-part-heading"
      }
    },
    {
      "type": "input_radio_group",
      "params": {
        // "valuetype": "number",
        "label": "Tab",
        "name": "smestaj_tab",
        "options": [
          // { "title": "SERVISI", "value": "SERVISI" },
          // { "title": "BLOG", "value": "BLOG" },
          // { "title": "OSTALO", "value": "OSTALO" },
          ..._zzyourmap_lib_tab_keys.map(tab_key => {
            return { "title": tab_key, "value": tab_key };
          }),
          { "title": "NONE (nema Tab samo marker)", "value": "NONE" },
        ],
        // "w": 320
      }
    },
  ];
};
//
/*
const _zzyourmap_preset_ostalo_v1_part_layer_checks = {
  //
  "check_layer_ugostitelji": false,
  "check_layer_aktivnosti": false,
  "check_layer_smestaji": false,
  "check_layer_prodavnice": false,
  "check_layer_servisi": false,
  "check_layer_ostalo": false,
  //
};
*/
export const _zzyourmap_formDefinition_ostalo_v1_formPart_layer_select = (formState, layer_titles_all = [], is_read_only) => {
  let _def = [
    {
      "type": "separator",
    },
    {
      "type": "html_tag_text",
      "params": {
        "title": "Layer (legenda)",
        "tag": "h4",
        "extraclass": "yourmap__form-part-heading"
      }
    },
    {
      "type": "input_checkbox",
      "params": {
        "readonly": (is_read_only === true ? true : false),
        "label": "Odaberi layer (legendu) sa mape ili unesi novi",
        "name": "smestaj_layer_is_manual",
        // "w": 320
      }
    },
  ];
  if (formState?.smestaj_layer_is_manual === true) {
    _def = [
      ..._def,
      {
        "type": "input_radio_group",
        "params": {
          "label": "Layer (legenda)",
          "name": "smestaj_layer",
          "options": [
            /*
            ..._zzyourmap_lib_legend_keys.map((legend_item) => {
              return { "title": legend_item, "value": legend_item };
            }),
            */
            ...layer_titles_all.map((layer_title) => {
              // const layer_key = _zzyourmap_convert_layer_title_to_layer_key(layer_title);
              return { "title": layer_title, "value": layer_title };
            }),
            { "title": "_alwaysshow", "value": "_alwaysshow" }
          ],
        }
      },
    ];
    if (formState.smestaj_layer_is_custom === true) {
      _def = [
        ..._def,
        {
          "type": "row",
          "params": {
            "children": [
              {
                "type": "input_checkbox",
                "params": {
                  "label": "Unos novog",
                  "name": "smestaj_layer_is_custom",
                  "w": 140
                }
              },
              {
                "type": "input_text",
                "params": {
                  "label": "smestaj_layer_custom_title",
                  "name": "smestaj_layer_custom_title",
                  "w": 240
                }
              },
            ],
          },
        },
      ];
    } else {
      _def = [
        ..._def,
        {
          "type": "row",
          "params": {
            "children": [
              {
                "type": "input_checkbox",
                "params": {
                  "label": "Unos novog",
                  "name": "smestaj_layer_is_custom",
                  "w": 140
                }
              },
            ],
          },
        },
      ];
    }
  }
  return _def;
};


// ----- image library FORMS, PRESETS...


export const _zzyourmap_preset_image_library_meta = {
  img_alt: '',
  img_title: '',
  note: '',
  tags_csv: '',
};
//
export const _zzyourmap_formDefinition_image_library_meta = [
  {
    "type": "input_text",
    "params": {
      "label": "img_alt",
      "name": "img_alt",
      // "w": 320
    }
  },
  {
    "type": "input_text",
    "params": {
      "label": "img_title",
      "name": "img_title",
      // "w": 320
    }
  },
  {
    "type": "input_text",
    "params": {
      "label": "note",
      "name": "note",
      // "w": 320
    }
  },
  {
    "type": "input_text",
    "params": {
      "readonly": true,
      "label": "tags_csv",
      "name": "tags_csv",
      // "w": 320
    }
  },
  {
    "type": "widget_tags_csv",
    "params": {
      "label": "Ukucajte tagove odvojene zarezom, enterom potvrdite. (npr: restoran, pizza, italijanski)",
      "name": "tags_csv",
      // "w": 320
    }
  },
];
//
export const _zzyourmap_prepare_entbox_for_submit_image_library_meta = (formState) => {
  /*
  TODO
  *** json data ???
  id
  of_id
  vr_tablename
  */
  const preset_keys = Object.keys(_zzyourmap_preset_image_library_meta);
  // const usable_keys = ['id', 'of_id', ...preset_keys]; // TODO
  const usable_keys = preset_keys;
  const prepared_entbox = js_utils.clone_obj_but_only_selected_keys(formState, usable_keys);
  return prepared_entbox;
};


// ----- FORMS, PRESETS...


// --- destination


//
export const _zzyourmap_preset_destination = {
  "destinacija_tip": "", // TODO
  "parent_destinacija_id": null, // TODO
  "komentar": "", //
  "map_legend_order_json": "",
  //
  "destinacija_slug": "kopaonik",
  "destinacija_naslov": "Kopaonik",
  "destinacija_poddestinacija_naslov": "Centar", //
  //
  "destinacija_podnaslov": "Najbolji ski centar u srbiji",
  "destinacija_duzi_podnaslov": "Otkrijte čarobnu planinu koja spaja netaknutu prirodu, bogatu istoriju i gostoprimstvo koje će vas oduševiti",
  "destinacija_naslov_sufix_za_liste": "na Zlatiboru", //
  "destinacija_naslov_za_smestaje": "Selekcija smeštaja na Zlatiboru", //
  "destinacija_naslov_za_restorane": "Selekcija restorana na Zlatiboru", //
  //
  "destinacija_main_img_filename": "",
  "destinacija_main_img_folder": "",
  "destinacija_map_img_filename": "",
  "destinacija_map_img_folder": "",
  "destinacija_map_img_w": 3840,
  "destinacija_map_img_h": 2160,
};
//
export const _zzyourmap_preset_subdestination = {
  "destinacija_tip": "", // TODO
  "parent_destinacija_id": null, // TODO
  "komentar": "", //
  //
  "destinacija_slug": "kopaonik",
  "destinacija_naslov": "Kopaonik",
  "destinacija_poddestinacija_naslov": "Centar", //
  //
  /*
  "destinacija_podnaslov": "Najbolji ski centar u srbiji",
  "destinacija_duzi_podnaslov": "Otkrijte čarobnu planinu koja spaja netaknutu prirodu, bogatu istoriju i gostoprimstvo koje će vas oduševiti",
  "destinacija_naslov_za_smestaje": "Selekcija smeštaja na Zlatiboru", //
  "destinacija_naslov_za_restorane": "Selekcija restorana na Zlatiboru", //
  */
  //
  "destinacija_main_img_filename": "",
  "destinacija_main_img_folder": "",
  "destinacija_map_img_filename": "",
  "destinacija_map_img_folder": "",
  "destinacija_map_img_w": 3840,
  "destinacija_map_img_h": 2160,
};
//
export const _zzyourmap_prepare_entbox_for_submit_destination = (formState) => {
  /*
  TODO
  *** json data ???
  id
  of_id
  vr_tablename
  */
  if (formState?.destinacija_tip === "DESTINATION") {
    const preset_keys = Object.keys(_zzyourmap_preset_destination); //
    // const usable_keys = ['id', 'of_id', ...preset_keys]; // TODO
    const usable_keys = preset_keys;
    const prepared_entbox = js_utils.clone_obj_but_only_selected_keys(formState, usable_keys);
    prepared_entbox.parent_destinacija_id = null; //
    return prepared_entbox;
  } else if (formState?.destinacija_tip === "SUBDESTINATION") {
    const preset_keys = Object.keys(_zzyourmap_preset_subdestination); //
    // const usable_keys = ['id', 'of_id', ...preset_keys]; // TODO
    const usable_keys = preset_keys;
    const prepared_entbox = js_utils.clone_obj_but_only_selected_keys(formState, usable_keys);
    if ('parent_destinacija_id' in prepared_entbox) {
      if (Number.parseInt(prepared_entbox.parent_destinacija_id) > 0) {
        prepared_entbox.parent_destinacija_id = Number.parseInt(prepared_entbox.parent_destinacija_id);
      }
    }
    return prepared_entbox;
  } else { // ERROR
    return false;
  }
};
//
export const _zzyourmap_formDefinition_destination = (formState, options_adm_parent_of_destination) => {
  const def_formPart_destination_or_subdestination = [
    {
      "type": "input_text",
      "params": {
        "label": "komentar",
        "name": "komentar",
        // "w": 320
      }
    },
    {
      "type": "input_radio_group",
      "params": {
        // "valuetype": "number",
        "label": "destinacija_tip",
        "name": "destinacija_tip",
        "options": [
          { "title": "Destinacija (ujedno i glavna poddestinacija)", "value": "DESTINATION" },
          { "title": "Poddestinacija", "value": "SUBDESTINATION" },
        ],
        // "w": 320
      }
    },
  ];
  //
  let def_formPart_common = [];
  const _def_formPart_common = [
    //
    {
      "type": "input_text",
      "params": {
        "label": "destinacija_slug",
        "name": "destinacija_slug",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "destinacija_naslov",
        "name": "destinacija_naslov",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "destinacija_poddestinacija_naslov",
        "name": "destinacija_poddestinacija_naslov",
        // "w": 320
      }
    },
    //
  ];
  if (formState?.destinacija_tip === "DESTINATION" || formState?.destinacija_tip === "SUBDESTINATION") {
    def_formPart_common = _def_formPart_common;
  }
  //
  let def_formPart_poddestinacija = [];
  const _def_formPart_poddestinacija = [
    {
      "type": "row",
      "params": {
        "children": [
          {
            "type": "select",
            "params": {
              "valuetype": "number",
              "label": "parent_destinacija_id",
              "name": "parent_destinacija_id",
              "options": [...options_adm_parent_of_destination],
              "w": 320
            }
          },
          {
            "type": "input_number",
            "params": {
              "readonly": true,
              "label": "",
              "name": "parent_destinacija_id",
              "w": 60
            }
          },
        ],
      },
    },
    //
  ];
  if (formState?.destinacija_tip === "SUBDESTINATION") {
    def_formPart_poddestinacija = _def_formPart_poddestinacija;
  }
  //
  let def_formPart_destinacija = [];
  const _def_formPart_destinacija = [
    //
    {
      "type": "separator",
    },
    {
      "type": "input_text",
      "params": {
        "label": "destinacija_podnaslov",
        "name": "destinacija_podnaslov",
        // "w": 320
      }
    },
    {
      "type": "textarea",
      "params": {
        "label": "destinacija_duzi_podnaslov",
        "name": "destinacija_duzi_podnaslov",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "destinacija_naslov_sufix_za_liste",
        "name": "destinacija_naslov_sufix_za_liste",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "destinacija_naslov_za_smestaje",
        "name": "destinacija_naslov_za_smestaje",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "destinacija_naslov_za_restorane",
        "name": "destinacija_naslov_za_restorane",
        // "w": 320
      }
    },
    //
  ];
  if (formState?.destinacija_tip === "DESTINATION") {
    def_formPart_destinacija = _def_formPart_destinacija;
  }
  //
  let def_formPart_main_img = [];
  let def_formPart_map = [];
  const _def_formPart_main_img = [..._zzyourmap_formDefinition_destination_formPart_main_img()];
  const _def_formPart_map = [
    //
    {
      "type": "separator",
    },
    {
      "type": "html_tag_text",
      "params": {
        "title": "Mapa ilustoravana",
        "tag": "h4",
        "extraclass": "yourmap__form-part-heading"
      }
    },
    {
      "type": "input_text",
      "params": {
        "readonly": true,
        "label": "destinacija_map_img_filename",
        "name": "destinacija_map_img_filename",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "readonly": true,
        "label": "destinacija_map_img_folder",
        "name": "destinacija_map_img_folder",
        // "w": 320
      }
    },
    {
      "type": "row",
      "params": {
        "children": [
          {
            "type": "input_number",
            "params": {
              // "readonly": true,
              "label": "Map image width",
              "name": "destinacija_map_img_w",
              "w": 140
            }
          },
          {
            "type": "input_number",
            "params": {
              // "readonly": true,
              "label": "Map image height",
              "name": "destinacija_map_img_h",
              "w": 140
            }
          },
        ]
      },
    },
  ];
  if (formState?.destinacija_tip === "DESTINATION") {
    def_formPart_main_img = _def_formPart_main_img;
  }
  if (formState?.destinacija_tip === "DESTINATION" || formState?.destinacija_tip === "SUBDESTINATION") {
    def_formPart_map = _def_formPart_map;
  }
  //
  //
  return [
    ...def_formPart_destination_or_subdestination,
    ...def_formPart_poddestinacija,
    ...def_formPart_common,
    ...def_formPart_destinacija,
    // ...def_formPart_main_img, // PREBACENO U KOMPONENTU
    ...def_formPart_map,
  ];
};

/*
  "destinacija_slug": "zlatibor",
 
  "destinacija_naslov": "Zlatibor",
  "destinacija_podnaslov": "Planinski raj za odmor i rekreaciju",
  "destinacija_duzi_podnaslov": "Na primer jedna duža rečenica koja može da predje u dva reda kao na primer: Otkrijte čarobnu planinu koja spaja netaknutu prirodu, bogatu istoriju i gostoprimstvo koje će Vas oduševiti",
 
destinacija_naslov	Kopaonik
destincija_podnaslov	Najbolji ski centar u srbiji
destinacija_duzi_podnaslov	Otkrijte čarobnu planinu koja spaja netaknutu prirodu, bogatu istoriju i gostoprimstvo koje će vas oduševiti
glavna slika	kopaonik_pocetna.png
svi_smestaji_naslov	Najbolji smestaji na kopaoniku
svi_smestaji_podnaslov	Istraži savete, preporuke i esencijalne informacije za tvoje savršeno putovanje na Kopaoniku.
*/


// --- smestaj, restoran, djuture...
//
export const _zzyourmap_preset_smestaj = () => {
  return {
    "parent_destinacija_id": null,
    "smestaj_naslov": "",
    "smestaj_podnaslov": "",
    "smestaj_opis": "",
    "smestaj_order_index": 0,
    "smestaj_adresa": "",
    "telefon": "",
    "telefon2": "",
    "mobilni": "",
    "mobilni2": "",
    "email": "",
    "email2": "",
    "websajt": "https://www.nekisajt.com",
    "kontakt_instagram_url": "",
    // "google_maps_link": "Link do lokacije na google mapama. Nije obavezno",
    "google_maps_iframe_src": "",
    "geo_uri": "",
    //
    ..._zzyourmap_preset_smestaj_part_checks,
    //
    "komentar": "", //
    //
    // "smestaj_tab_is_manual": false, //
    // "smestaj_tab": null, //
    "smestaj_layer": null, //
    "smestaj_layer_is_manual": false, //
    "smestaj_layer_is_custom": false, //
    "smestaj_layer_custom_title": null, //
    //
    "smestaj_main_img_filename": "",
    "smestaj_main_img_folder": "",
    //
    "smestaj_marker_enabled": true,
    "smestaj_marker_animacija": "",
    "smestaj_marker_img_filename": "",
    "smestaj_marker_img_folder": "",
    "smestaj_marker_img_w": 40,
    "smestaj_marker_img_h": 40,
    "smestaj_marker_img_left": 0,
    "smestaj_marker_img_bottom": 0,
    // iconAnchor	Point	null	The coordinates of the "tip" of the icon (relative to its top left corner). The icon will be aligned so that this point is at the marker's geographical location. Centered by default if size is specified, also can be set in CSS with negative margins.
    "smestaj_marker_img_anchor_left": 0,
    "smestaj_marker_img_anchor_top": 0,
    "smestaj_marker_zoom_disabled": false,
    "smestaj_marker_zoom_follow_enabled": false,
    "smestaj_marker_zoom_step_enabled": true,
    "smestaj_marker_is_link": false,
    "smestaj_marker_link_href": null,
    "smestaj_marker_link_target": "_blank",
    //
    "gallery_img_arr": [],
  };
};
//
export const _zzyourmap_prepare_entbox_for_submit_smestaj = (formState, subformGalleryArr) => {
  /*
  TODO
  *** json data ???
  id
  of_id
  vr_tablename
  */
  // const preset_keys = Object.keys(_zzyourmap_preset_smestaj());
  const preset_keys = ['vr_tablename', ...Object.keys(_zzyourmap_preset_smestaj())]; // TODO
  // const usable_keys = ['id', 'of_id', ...preset_keys]; // TODO
  const usable_keys = preset_keys;
  const prepared_entbox = js_utils.clone_obj_but_only_selected_keys(formState, usable_keys);
  if (prepared_entbox.smestaj_marker_zoom_disabled === true) {
    prepared_entbox.smestaj_marker_zoom_follow_enabled = false;
    prepared_entbox.smestaj_marker_zoom_step_enabled = false;
  } else if (prepared_entbox.smestaj_marker_zoom_follow_enabled === true) {
    prepared_entbox.smestaj_marker_zoom_step_enabled = false;
  } else {
    prepared_entbox.smestaj_marker_zoom_follow_enabled = false;
    prepared_entbox.smestaj_marker_zoom_step_enabled = true;
  }
  if (prepared_entbox.smestaj_marker_is_link === true) {
    if (typeof prepared_entbox.smestaj_marker_link_href === 'string') {
      prepared_entbox.smestaj_marker_link_href = prepared_entbox.smestaj_marker_link_href.trim();
      prepared_entbox.smestaj_marker_link_href = rapidozi_contact_utils.fix_contact_website_url(prepared_entbox.smestaj_marker_link_href);
    } else {
      prepared_entbox.smestaj_marker_link_href = null;
    }
    if (prepared_entbox.smestaj_marker_link_target !== '_self') {
      prepared_entbox.smestaj_marker_link_target = '_blank';
    }
  } else {
    prepared_entbox.smestaj_marker_link_href = null;
    prepared_entbox.smestaj_marker_link_target = '_blank';
  }
  if (prepared_entbox.smestaj_layer_is_manual === true) {
    if (prepared_entbox.smestaj_layer_is_custom === true) { // CASE layer is custom title
      const smestaj_layer_custom_title = _zzyourmap_fix_layer_title(prepared_entbox.smestaj_layer_custom_title);
      if (typeof prepared_entbox.smestaj_layer_custom_title === 'string') { // valid
        prepared_entbox.smestaj_layer_custom_title = smestaj_layer_custom_title;
        prepared_entbox.smestaj_layer = null;
      } else { // invalid
        prepared_entbox.smestaj_layer_custom_title = null;
      }
    } else { // CASE layer is selected
      if (Easy69_v1.is_string_not_empty(prepared_entbox.smestaj_layer)) { // valid
        // do nothing
      } else { // invalid
        prepared_entbox.smestaj_layer = null;
      }
    }
  }
  prepared_entbox.gallery_img_arr = subformGalleryArr;
  if ('parent_destinacija_id' in prepared_entbox) {
    if (Number.parseInt(prepared_entbox.parent_destinacija_id) > 0) {
      prepared_entbox.parent_destinacija_id = Number.parseInt(prepared_entbox.parent_destinacija_id);
    }
  }
  console.log('prepared_entbox', prepared_entbox);
  return prepared_entbox;
};
//
export const _zzyourmap_formDefinition_smestaj = (formState, options_adm_parent_of_smestaj, layer_titles_all) => {
  return [
    //
    {
      "type": "input_text",
      "params": {
        "label": "komentar",
        "name": "komentar",
        // "w": 320
      }
    },
    ..._zzyourmap_formDefinition_smestaj_formPart_vr_tablename(),
    ..._zzyourmap_formDefinition_ostalo_v1_formPart_layer_select(formState, layer_titles_all),
    {
      "type": "separator",
    },
    {
      "type": "row",
      "params": {
        "children": [
          {
            "type": "select",
            "params": {
              "valuetype": "number",
              "label": "parent_destinacija_id",
              "name": "parent_destinacija_id",
              "options": [...options_adm_parent_of_smestaj],
              "w": 320
            }
          },
          {
            "type": "input_number",
            "params": {
              "readonly": true,
              "label": "",
              "name": "parent_destinacija_id",
              "w": 60
            }
          },
        ],
      },
    },

    {
      "type": "input_text",
      "params": {
        "label": "smestaj_naslov",
        "name": "smestaj_naslov",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "smestaj_podnaslov",
        "name": "smestaj_podnaslov",
        // "w": 320
      }
    },
    {
      "type": "textarea",
      "params": {
        "label": "smestaj_opis",
        "name": "smestaj_opis",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "smestaj_adresa",
        "name": "smestaj_adresa",
        // "w": 320
      }
    },
    //
    // ..._zzyourmap_formDefinition_smestaj_formPart_kontakt(),
    //
    // ..._zzyourmap_formDefinition_smestaj_formPart_checks(),
    //
    // ..._zzyourmap_formDefinition_smestaj_formPart_main_img(),
    //
    // ..._zzyourmap_formDefinition_smestaj_formPart_marker(),
    //
  ];
};


// --- ostalo v1
//
export const _zzyourmap_preset_ostalo_v1 = () => {
  return {
    "parent_destinacija_id": null,
    "smestaj_naslov": "Olive Branch Mediterranean",
    "smestaj_podnaslov": "Moderan hotel u centru Zlatibora",
    "smestaj_opis": "Opis za marker popup",
    "smestaj_order_index": 0,
    //
    // ..._zzyourmap_preset_smestaj_part_checks,
    //
    "komentar": "", //
    //
    "smestaj_tab_is_manual": false, //
    "smestaj_tab": null, //
    "smestaj_layer": null, //
    "smestaj_layer_is_manual": true, //
    "smestaj_layer_is_custom": false, //
    "smestaj_layer_custom_title": null, //
    //
    // "_special_blog_post_data": null, //
    "_special_blog_post_data": _zzyourmap_make_empty_special_blog_post_data(), //
    //
    "smestaj_main_img_filename": "",
    "smestaj_main_img_folder": "",
    //
    "smestaj_marker_enabled": true,
    "smestaj_marker_animacija": "",
    "smestaj_marker_img_filename": "",
    "smestaj_marker_img_folder": "",
    "smestaj_marker_img_w": 40,
    "smestaj_marker_img_h": 40,
    "smestaj_marker_img_left": 0,
    "smestaj_marker_img_bottom": 0,
    // iconAnchor	Point	null	The coordinates of the "tip" of the icon (relative to its top left corner). The icon will be aligned so that this point is at the marker's geographical location. Centered by default if size is specified, also can be set in CSS with negative margins.
    "smestaj_marker_img_anchor_left": 0,
    "smestaj_marker_img_anchor_top": 0,
    "smestaj_marker_zoom_disabled": false,
    "smestaj_marker_zoom_follow_enabled": false,
    "smestaj_marker_zoom_step_enabled": true,
    "smestaj_marker_is_link": false,
    "smestaj_marker_link_href": null,
    "smestaj_marker_link_target": "_blank",
    //
    "gallery_img_arr": [],
  };
};
//
export const _zzyourmap_prepare_entbox_for_submit_ostalo_v1 = (formState, payload) => {
  /*
  TODO
  *** json data ???
  id
  of_id
  vr_tablename
  */
  const preset_keys = Object.keys(_zzyourmap_preset_ostalo_v1());
  // const usable_keys = ['id', 'of_id', ...preset_keys]; // TODO
  const usable_keys = preset_keys;
  const prepared_entbox = js_utils.clone_obj_but_only_selected_keys(formState, usable_keys);
  if (prepared_entbox.smestaj_marker_zoom_disabled === true) {
    prepared_entbox.smestaj_marker_zoom_follow_enabled = false;
    prepared_entbox.smestaj_marker_zoom_step_enabled = false;
  } else if (prepared_entbox.smestaj_marker_zoom_follow_enabled === true) {
    prepared_entbox.smestaj_marker_zoom_step_enabled = false;
  } else {
    prepared_entbox.smestaj_marker_zoom_follow_enabled = false;
    prepared_entbox.smestaj_marker_zoom_step_enabled = true;
  }
  if (prepared_entbox.smestaj_marker_is_link === true) {
    if (typeof prepared_entbox.smestaj_marker_link_href === 'string') {
      prepared_entbox.smestaj_marker_link_href = prepared_entbox.smestaj_marker_link_href.trim();
      prepared_entbox.smestaj_marker_link_href = rapidozi_contact_utils.fix_contact_website_url(prepared_entbox.smestaj_marker_link_href);
    } else {
      prepared_entbox.smestaj_marker_link_href = null;
    }
    if (prepared_entbox.smestaj_marker_link_target !== '_self') {
      prepared_entbox.smestaj_marker_link_target = '_blank';
    }
  } else {
    prepared_entbox.smestaj_marker_link_href = null;
    prepared_entbox.smestaj_marker_link_target = '_blank';
  }
  if (prepared_entbox.smestaj_layer_is_manual === true) {
    if (prepared_entbox.smestaj_layer_is_custom === true) { // CASE layer is custom title
      const smestaj_layer_custom_title = _zzyourmap_fix_layer_title(prepared_entbox.smestaj_layer_custom_title);
      if (typeof prepared_entbox.smestaj_layer_custom_title === 'string') { // valid
        prepared_entbox.smestaj_layer_custom_title = smestaj_layer_custom_title;
        prepared_entbox.smestaj_layer = null;
      } else { // invalid
        prepared_entbox.smestaj_layer_custom_title = null;
      }
    } else { // CASE layer is selected
      if (Easy69_v1.is_string_not_empty(prepared_entbox.smestaj_layer)) { // valid
        // do nothing
      } else { // invalid
        prepared_entbox.smestaj_layer = null;
      }
    }
  }
  if (prepared_entbox?._special_blog_post_data?.is_editorjs === true &&
    frfr_alien_editorjs_editorjs_renderable_data_validator_quick_incomplete(_zzyourmap_extract_editorjs_renderable_data(prepared_entbox?._special_blog_post_data))) {
    // preserve valid
  } else {
    prepared_entbox._special_blog_post_data = null;
  }
  if (prepared_entbox.smestaj_tab === "NONE") { // u slucaju da je NONE ne cuvamo blog post podatke
    prepared_entbox._special_blog_post_data = null;
  }
  if ('parent_destinacija_id' in prepared_entbox) {
    if (Number.parseInt(prepared_entbox.parent_destinacija_id) > 0) {
      prepared_entbox.parent_destinacija_id = Number.parseInt(prepared_entbox.parent_destinacija_id);
    }
  }
  return prepared_entbox;
};
//
export const _zzyourmap_formDefinition_ostalo_v1 = (formState, options_adm_parent_of_smestaj, layer_titles_all) => {
  const def_formPart_ostalo_tip = [
    {
      "type": "input_text",
      "params": {
        "label": "komentar",
        "name": "komentar",
        // "w": 320
      }
    },
    /*
    {
      "type": "html_tag_text",
      "params": {
        "title": "Layer checks...",
        "tag": "h4",
      }
    },
    */
    ..._zzyourmap_formDefinition_smestaj_formPart_tab_select(formState),
    ..._zzyourmap_formDefinition_ostalo_v1_formPart_layer_select(formState, layer_titles_all, true),
    {
      "type": "separator",
    },
    {
      "type": "input_checkbox",
      "params": {
        "label": "Prikaži marker na mapi",
        "name": "smestaj_marker_enabled",
        // "w": 320
      }
    },
    {
      "type": "separator",
    },
  ];
  //
  let def_formPart_common = [];
  const _def_formPart_common = [
    //
    {
      "type": "input_text",
      "params": {
        "label": "smestaj_naslov",
        "name": "smestaj_naslov",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "smestaj_podnaslov",
        "name": "smestaj_podnaslov",
        // "w": 320
      }
    },
    {
      "type": "textarea",
      "params": {
        "label": "smestaj_opis",
        "name": "smestaj_opis",
        // "w": 320
      }
    },
    //
  ];
  def_formPart_common = _def_formPart_common;
  /*
  if (formState?.destinacija_tip === "DESTINATION" || formState?.destinacija_tip === "SUBDESTINATION") {
    def_formPart_common = _def_formPart_common;
  }
  */
  //
  let def_formPart_main_img = [];
  const _def_formPart_main_img = [..._zzyourmap_formDefinition_smestaj_formPart_main_img()];
  def_formPart_main_img = _def_formPart_main_img;
  //
  const _def_aprt_parent_destinacija_id = [
    {
      "type": "row",
      "params": {
        "children": [
          {
            "valuetype": "number",
            "type": "select",
            "params": {
              "label": "parent_destinacija_id",
              "name": "parent_destinacija_id",
              "options": [...options_adm_parent_of_smestaj],
              "w": 320
            }
          },
          {
            "type": "input_number",
            "params": {
              "readonly": true,
              "label": "",
              "name": "parent_destinacija_id",
              "w": 60
            }
          },
        ],
      },
    },
  ];
  const def_aprt_parent_destinacija_id = _def_aprt_parent_destinacija_id;
  //
  let def_formPart_marker = [];
  const _def_formPart_marker = [..._zzyourmap_formDefinition_smestaj_formPart_marker()];
  if (formState.smestaj_marker_enabled === true) {
    def_formPart_marker = _def_formPart_marker; // PREBACENO U KOMPONNTU
  }
  //
  //
  return [
    ...def_aprt_parent_destinacija_id,
    ...def_formPart_common,
    ...def_formPart_ostalo_tip,
    ...def_formPart_main_img,
    // ...def_formPart_marker, // PREBACENO U KOMPONNTU
    // ...def_formPart_poddestinacija,
    // ...def_formPart_destinacija,
    // ...def_formPart_main_img,
    // ...def_formPart_map,
  ];

  ////
  //
  //
  return [
    {
      "type": "row",
      "params": {
        "children": [
          {
            "valuetype": "number",
            "type": "select",
            "params": {
              "label": "parent_destinacija_id",
              "name": "parent_destinacija_id",
              "options": [...options_adm_parent_of_smestaj],
              "w": 320
            }
          },
          {
            "type": "input_number",
            "params": {
              "readonly": true,
              "label": "",
              "name": "parent_destinacija_id",
              "w": 60
            }
          },
        ],
      },
    },

    {
      "type": "input_text",
      "params": {
        "label": "smestaj_naslov",
        "name": "smestaj_naslov",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "smestaj_podnaslov",
        "name": "smestaj_podnaslov",
        // "w": 320
      }
    },
    {
      "type": "textarea",
      "params": {
        "label": "smestaj_opis",
        "name": "smestaj_opis",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "smestaj_adresa",
        "name": "smestaj_adresa",
        // "w": 320
      }
    },
    //
    ..._zzyourmap_formDefinition_smestaj_formPart_kontakt(),
    //
    ..._zzyourmap_formDefinition_smestaj_formPart_checks(),
    //
    {
      "type": "input_text",
      "params": {
        "label": "komentar",
        "name": "komentar",
        // "w": 320
      }
    },
    //
    ..._zzyourmap_formDefinition_smestaj_formPart_main_img(),
    //
    ..._zzyourmap_formDefinition_smestaj_formPart_marker(),
    //
  ];
};

